import axios from 'axios';


export function getFilter({filter, waluta, naklady, wielkosc_przedsiebiorstwa}) {
  return axios.get("/kalkulator_pub/filtr", {
    params: {
      sektor: "uslugi", // TODO?
      waluta,
      naklady,
      wielkosc_przedsiebiorstwa
    }
  })
  .then(r => {
    return {
      ...filter,
      gminyIds: r.data.gminy,
      ofertyIds: r.data.oferty,
    };
  });
}
